import { render, staticRenderFns } from "./ScrollingNumbers.vue?vue&type=template&id=7ed94ed2&"
import script from "./ScrollingNumbers.vue?vue&type=script&lang=js&"
export * from "./ScrollingNumbers.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingNumbers.vue?vue&type=style&index=0&id=7ed94ed2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports